import React from 'react';
import '../App.css';
import { Button } from './Button';
import './VideoSection.css';

function VideoSection() {
  return (
    <div className='slide-container' id='video'>
        <h1>Discover Our World of Robotics and Coding</h1>
        <p>Watch our video to explore how we tailor our programs to inspire and educate your child, and how we make STEM fun and engaging.</p>
        <div className="blocks__container">
        <iframe className='video-frame' src="https://www.youtube.com/embed/mU-UUltdJOQ?si=eFmZ27WkelONeV6L" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
    </div>
  )
}

export default VideoSection
